<template>
  <div class="weui-tabbar bottom_tabbar">
    <router-link to="/" class="weui-tabbar__item sy_nav">
      <img src="../assets/images/nav_Home01.png" alt="" class="weui-tabbar__icon">
      <p class="weui-tabbar__label">首页</p>
    </router-link>
    <router-link to="/H040020" class="weui-tabbar__item jchd_nav">
      <img src="../assets/images/nav_Activity01.png" alt="" class="weui-tabbar__icon">
      <p class="weui-tabbar__label">活动</p>
    </router-link>
    <a href="https://eblock.qiyu-soft.com/01.aspx" class="weui-tabbar__item yyst_nav">
      <img src="../assets/images/nav_Reservation01.png" alt="" class="weui-tabbar__icon">
      <p class="weui-tabbar__label">预约</p>
    </a>
    <router-link to="/H030010" class="weui-tabbar__item wd_nav">
      <img src="../assets/images/nav_My01.png" alt="" class="weui-tabbar__icon">
      <p class="weui-tabbar__label">我的</p>
    </router-link>
  </div>
</template>

<script>
export default {
  props: ["navs"],
  data () {
    return {
      sy: require("../assets/images/nav_Home02.png"),
      jchd: require("../assets/images/nav_Activity02.png"),
      yyst: require("../assets/images/nav_Reservation02.png"),
      wd: require("../assets/images/nav_My02.png"),
    }
  },
  mounted () {
    $(".bottom_tabbar .weui-tabbar__item.active").removeClass("active")
    if (this.navs.sy) {
      $(".sy_nav").find("img").attr("src",this.sy)
      $(".sy_nav").addClass("active")
    } else if (this.navs.jchd) {
      $(".jchd_nav").find("img").attr("src",this.jchd)
      $(".jchd_nav").addClass("active")
    } else if (this.navs.yyst) {
      $(".yyst_nav").find("img").attr("src",this.yyst)
      $(".yyst_nav").addClass("active")
    }else if (this.navs.wd) {
      $(".wd_nav").find("img").attr("src",this.wd)
      $(".wd_nav").addClass("active")
    }
  }
}
</script>

<style>
  @import '../assets/css/common.css';
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue